import { DEFAULT_NOTIFICATION_KEYS } from './constants';

export function getNotifications(contextId, hasGP = false) {
  return [
    {
      id: DEFAULT_NOTIFICATION_KEYS.OFFLINE_MODE,
      isRead: isNotificationRead(DEFAULT_NOTIFICATION_KEYS.OFFLINE_MODE, contextId),
      hasGP,
      contextId,
    },
  ];
}

function isNotificationRead(id, contextId) {
  return window.localStorage.getItem(['NOTIFICATION_READ', contextId, id].join('_')) === 'true';
}

export function setNotificationRead({ id, contextId }) {
  window.localStorage.setItem(['NOTIFICATION_READ', contextId, id].join('_'), 'true');
}

export function setNotificationDismissed({ id, contextId }) {
  window.localStorage.setItem(['NOTIFICATION_DISMISS_TIME', contextId, id].join('_'), Date.now().toString());
}

export function isNotificationDismissed({ id, contextId }) {
  const dismissTime = window.localStorage.getItem(['NOTIFICATION_DISMISS_TIME', contextId, id].join('_'));

  if (!dismissTime) {
    return false;
  }

  return Date.now() - dismissTime < 24 * 60 * 60 * 1000;
}
